import { LineSvgProps } from '@nivo/line';

import { CHANNEL_TICK_VALUE, EEG_CHANNEL_LABELS, EEG_LONGITUDINAL_CHANNEL_LABELS } from '../../const';

const yLabelValue = (labels: string[]) => {
  const yLabelValue: number[] = [0];
  for (let i = 1; i <= labels.length * 2; i++) {
    yLabelValue.push(i * CHANNEL_TICK_VALUE);
  }
  return yLabelValue;
};

const longitudinalLabels = yLabelValue(EEG_LONGITUDINAL_CHANNEL_LABELS);
const linkedEarsLabels = yLabelValue(EEG_CHANNEL_LABELS);

const createEEGConfig = (yValues: number[], colors: string[], ml: number): Omit<LineSvgProps, 'data'> => {
  return {
    margin: { top: 0, right: 10, bottom: 10, left: ml },
    yScale: {
      type: 'linear',
      max: (yValues.length - 1) * CHANNEL_TICK_VALUE,
      clamp: true,
    },
    xScale: {
      type: 'linear',
    },
    isInteractive: false,
    axisLeft: null,
    axisBottom: null,
    enablePoints: false,
    curve: 'monotoneX',
    animate: false,
    gridYValues: yValues,
    colors: colors,
  };
};

export const LongitudinalConfig: Omit<LineSvgProps, 'data'> = createEEGConfig(
  longitudinalLabels,
  [
    '#00d755',
    '#00d755',
    '',
    '#20bbf9',
    '#20bbf9',
    '#20bbf9',
    '#20bbf9',
    '',
    '#20bbf9',
    '#20bbf9',
    '#20bbf9',
    '#20bbf9',
    '',
    '#ff3a52',
    '#ff3a52',
    '#ff3a52',
    '#ff3a52',
    '',
    '#ff3a52',
    '#ff3a52',
    '#ff3a52',
    '#ff3a52',
  ],
  65
);
export const LinkedEarsConfig: Omit<LineSvgProps, 'data'> = createEEGConfig(
  linkedEarsLabels,
  [
    '#00d755',
    '#00d755',
    '#20bbf9',
    '#20bbf9',
    '#20bbf9',
    '#20bbf9',
    '#20bbf9',
    '#20bbf9',
    '#ffa900',
    '#ffa900',
    '#ffa900',
    '#ffa900',
    '#ff3a52',
    '#ff3a52',
    '#ff3a52',
    '#ff3a52',
    '#ff3a52',
    '#ff3a52',
    '#ff3a52',
  ],
  10
);

export const HRVSignalChartConfig: Omit<LineSvgProps, 'data'> = {
  margin: { top: 10, right: 10, bottom: 10, left: 20 },
  yScale: { type: 'linear', max: 'auto', min: 'auto', clamp: true },
  xScale: { type: 'linear', max: 'auto', min: 0 },
  axisLeft: {
    format: () => '',
    tickSize: 10,
  },
  isInteractive: false,
  enablePoints: false,
  curve: 'monotoneX',
  animate: false,
  markers: [
    {
      axis: 'y',
      value: 0,
    },
  ],
  theme: {},
  colors: ['#ff3a52'],
};
